<template>

    <animated-background>

        <v-dialog persistent transition="scale-transition" max-width="500" v-model="dialog">
            <v-card>
                <v-toolbar
                    light
                    prominent
                    elevation="10"
                    :src="cdnBaseUrl('/img/login.png')"
                />

                <v-container class="ph-4 pt-0">
                    <v-row no-gutters>

                        <v-col cols="12">
                            <v-card-text>

                                <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">

                                    <validation-provider
                                        mode="lazy"
                                        name="email address"
                                        rules="required|email|max:100"
                                        v-slot="{ errors }">

                                        <v-text-field
                                            :error-messages="errors"
                                            label="Email address"
                                            v-model="data.email"
                                            autocomplete="off"
                                        ></v-text-field>

                                    </validation-provider>

                                    <validation-provider
                                        mode="lazy"
                                        name="password"
                                        rules="required|min:7|max:100"
                                        v-slot="{ errors }">

                                        <v-text-field
                                            label="Password"
                                            :error-messages="errors"
                                            v-model="data.password"
                                            @keyup.enter="submitForm"
                                            :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="() => (passwordVisible = !passwordVisible)"
                                            :type="passwordVisible ? 'text' : 'password'"
                                            autocomplete="off"
                                        ></v-text-field>

                                    </validation-provider>

                                </validation-observer>

                            </v-card-text>

                            <v-card-actions>
                                <v-btn class="ml-2 mb-2" color="primary" :loading="form.busy" @click="submitForm">
                                    Login
                                </v-btn>
                                <v-btn text class="ml-2 mb-2" @click="showResetPassword">Forgot password?</v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-container>

            </v-card>
        </v-dialog>

    </animated-background>

</template>

<script>

import Form from '../../../components/forms/Form';
import ToolbarPage from '../../../components/UI/ToolbarPage';
import AnimatedBackground from "../../../components/UI/AnimatedBackground";

export default {

    components: {
        AnimatedBackground,
        ToolbarPage
    },

    data() {
        return {
            data: {
                email: null,
                password: null,
            },
            valid: true,
            dialog: false,
            passwordVisible: false,
            form: null
        }
    },

    mounted() {

        if (Spark.trialExpired) {
            this.$router.push('/spa/trialexpired');
            return;
        }

        // By pass this screen if user is authenticated
        if (Spark.session.auth) {
            this.$router.push('/spa/dashboard');
        } else {
            setTimeout(() => {
                this.dialog = true;
            }, 200);
        }
    },

    watch: {
        $route(to, from) {
            if (to.path === '/spa/login') {
                this.dialog = true;
            }
        }
    },

    methods: {

        submitForm() {
            this.$refs.validationObserver.validate()
                .then(isValid => {
                    if (isValid) {

                        this.form.data.email = this.data.email;
                        this.form.data.password = this.data.password;

                        this.form.send('post', '/login')
                            .then((response) => {

                                this.dialog = false;

                                // Here the system app.2fa_force is set to false
                                // so we need to bypass the 2FA token authentication
                                if (response.data.message === 'authenticated') {
                                    setTimeout(() => {
                                        window.location.replace('/spa/dashboard');
                                    }, 100);
                                } else {
                                    // Must reload whole page as CSRF token changes as user
                                    // is authentication. Alternative one could read the returned
                                    // cookie and update the value in axios
                                    // NOTE: Total time sink, Laravel does not allow over riding XSRF -cookie
                                    setTimeout(() => {
                                        window.location.replace('/spa/token');
                                    }, 100);
                                }
                            })
                            .catch((error) => {

                                if (error.status === 429) {
                                    Bus.$emit('flash-message', {
                                        type: 'error',
                                        message: 'Slow down! Too many requests!'
                                    });
                                }

                                if (error.status === 422) {
                                    Bus.$emit('flash-message', {
                                        type: 'error',
                                        message: 'Entered credentials do not match our records!'
                                    });
                                }
                            });
                    }
                });
        },

        showResetPassword() {
            this.$router.push('/spa/password-reset')
        },
    },

    created() {
        this.form = new Form(this.data);
    }
}
</script>
